import { useCallback, useEffect, useState } from "react";
import Api, { IApi } from "../services/Api";
import { getApiEndpoint } from "../services/Config";
import { ErrorApi } from "../types";

function useFetch<T>(
  params: any, // paramètres requis pour appeler l'API (dans le path, body...)
  url: string, // URL qui correspond à l'operationID de l'API
  shouldExecute?: boolean, // boolean pour déclencher l'exécution de l'API
  reinitializeResponse?: boolean // reinitialize response à chaque fetching
): {
  response: T | undefined;
  error: ErrorApi | undefined;
  fetching: boolean;
  fetchData: () => Promise<void>;
} {
  const api: IApi = Api.create(getApiEndpoint() || "http://localhost:8090"); // récupération de l'url de l'api (intégration, recette, production... )

  // State pour stocker les retours
  const [response, setResponse] = useState<T | undefined>(undefined);
  const [error, setError] = useState<ErrorApi | undefined>(undefined);
  const [fetching, setFetching] = useState<boolean>(false);
  const fetchData = async (): Promise<void> => {
    try {
      let res;
      if (params) {
        res = await api[url](params);
      } else {
        res = await api[url]();
      }
      setResponse(res);
      setFetching(false);
      setError(undefined);
    } catch (error) {
      setResponse(undefined);
      setError(error);
      setFetching(false);
    }
  };
  useEffect(() => {
    // appel en asynchrone de l'API
    if (shouldExecute) {
      setFetching(true);
      fetchData();
      if (reinitializeResponse) {
        setResponse(undefined);
      }
    }
  }, [shouldExecute, params]); // l'Appel de l'API se fait seulement si shouldExecute et params sont renseignés ET se relance seulement si ces deux paramètres ont été modifié
  return { response, error, fetching, fetchData: useCallback(fetchData, []) };
}
export default useFetch;
